import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate} from "react-router-dom";
import { useFormik } from "formik"; 
import { signupProviderSchema } from "../../../services/validator";
import { toast } from "react-toastify";
import useToast from "../../../helpers/useToast";
import { TextField, Button, Box, Typography, IconButton, InputAdornment, Chip } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete'; 
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useEncryption from "../../../services/useEncryption";
import { providerDetailsApi } from "../../../api/adminApi/adminApi";
import { signupProviderApi } from "../../../api/authApi/authApi";

const SignupProvider = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toastOptions = useToast();
  const { encryptData, decryptData } = useEncryption();
  const { providerId } = useParams();
  const navigate = useNavigate();



 useEffect(() => {
    const fetchProvider = async () => {
      try {
        const response = await providerDetailsApi(providerId); 
        const result = decryptData(response.data.data);
        formik.setValues({
          organizationName: result.organizationName,
          organizationType: result.organizationType,
          phoneNumber: result.phoneNumber,
          email: result.email,
          streetAddress: result.streetAddress,
          city: result.city,
          state: result.state,
          zipCode: result.zipCode,
          latitude: result.latitude,
          longitude: result.longitude,
        });
      } catch (error) {
        console.error('Error fetching provider:', error);
      }
    };

    fetchProvider();
  }, [providerId]);
  
  const initialValues = {
    organizationName: '',
    organizationType: '',
    phoneNumber: '',
    email: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    latitude: '',
    longitude: '',
    password: '',
    confirmPassword: '',
  };

  const validationSchema = signupProviderSchema;

  const onSubmit = async (values, { resetForm }) => {
    try {
        const data = encryptData(values);
        const response = await signupProviderApi(data, providerId); 
        toast.success(response.data.message,toastOptions);
        navigate("/");
        resetForm();
    } catch (error) {
        toast.error(error.response.data.message, toastOptions);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };


  return (
    <Box className="auth-page" sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Box className="auth-form" sx={{ width: "30%", height: "1200px", padding: "20px", border: "1px solid gray",  borderRadius: "10px", marginTop: "2%", marginBottom: "2%", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"}}>
        <Typography variant="h4" gutterBottom align="center" sx={{color: "#0870AF "}}>
          Sign Up
        </Typography>
        <form onSubmit={formik.handleSubmit}>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="organizationName"
            name="organizationName"
            label="Organization Name"
            value={formik.values.organizationName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.organizationName && Boolean(formik.errors.organizationName)}
            helperText={formik.touched.organizationName && formik.errors.organizationName}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="organizationType"
                name="organizationType"
                label="Organization Type"
                value={formik.values.organizationType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.organizationType && Boolean(formik.errors.organizationType)}
                helperText={formik.touched.organizationType && formik.errors.organizationType}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="Phone Number"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="email"
                name="email"
                label="Email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                inputProps={{readOnly: true,}}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="streetAddress"
            name="streetAddress"
            label="Street Address"
            value={formik.values.streetAddress}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.streetAddress && Boolean(formik.errors.streetAddress)}
            helperText={formik.touched.streetAddress && formik.errors.streetAddress}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="city"
            name="city"
            label="City"
            value={formik.values.city}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.city && Boolean(formik.errors.city)}
            helperText={formik.touched.city && formik.errors.city}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="state"
            name="state"
            label="State"
            value={formik.values.state}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.state && Boolean(formik.errors.state)}
            helperText={formik.touched.state && formik.errors.state}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="zipCode"
                name="zipCode"
                label="Zip Code"
                value={formik.values.zipCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.zipCode && Boolean(formik.errors.zipCode)}
                helperText={formik.touched.zipCode && formik.errors.zipCode}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="latitude"
            name="latitude"
            label="Latitude"
            value={formik.values.latitude}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.latitude && Boolean(formik.errors.latitude)}
            helperText={formik.touched.latitude && formik.errors.latitude}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
            fullWidth
            id="longitude"
            name="longitude"
            label="Longitude"
            value={formik.values.longitude}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.longitude && Boolean(formik.errors.longitude)}
            helperText={formik.touched.longitude && formik.errors.longitude}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="password"
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
            />
        </Box>
        <Box className="input-field-section" sx={{ height: "80px"}}>
            <TextField
                fullWidth
                id="confirmPassword"
                name="confirmPassword"
                label="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleToggleConfirmPasswordVisibility} edge="end">
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
            />
        </Box>
        
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            Sign Up
          </Button>
        </form>
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Typography variant="body2">
            Already have an account? <Link to="/">Login</Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SignupProvider;
